import axiosClient from '../api/AxiosConfig';

export const MenuService = {
  GetMenu: async () => (await axiosClient.get('/menu/private')).data,
  CreateMenu: async (data) => (await axiosClient.post('/menu', data)).data,
  EditMenu: async (id, data) => (await axiosClient.put(`/menu/${id}/edit`, data)).data,
  GetMenuById: async (id) => (await axiosClient.get(`/menu/${id}/view`)).data,
  EditMenuDetail: async (id, data) => (await axiosClient.put(`menu/${id}/detail`, data)).data,
  CreateMenuDetail: async (id, data) => (await axiosClient.post(`/menu/${id}/detail`, data)).data,
  DeleteMenu: async (id) => (await axiosClient.delete(`/menu/${id}/delete`)).data,
};
